import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { CLASE_FUERA_DE_IMAGEN_SUPER_EJECUTIVO, TEXTOS_DESCARGA_SUPER_EJECUTIVO } from '../super-ejecutivo.constants';

/**
 * Botón de descarga de una gráfica o una tabla del Super Ejecutivo, con su menú: imagen (PNG) o Excel. No sale en la
 * imagen descargada. Quien lo usa arma el archivo.
 */
@Component({
  selector: 'app-super-ejecutivo-descarga',
  templateUrl: './super-ejecutivo-descarga.component.html',
  styleUrl: './super-ejecutivo-descarga.component.css',
  imports: [MatIconButton, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger, MatTooltip],
  host: { class: CLASE_FUERA_DE_IMAGEN_SUPER_EJECUTIVO },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuperEjecutivoDescargaComponent {
  /** Qué se descarga, para el tooltip y la etiqueta accesible: "Descargar gráfica", "Descargar tabla". */
  public readonly etiqueta = input.required<string>();
  /** Hay una descarga en curso: se deshabilita para no armar el mismo archivo dos veces. */
  public readonly descargando = input(false);
  public readonly imagen = output<void>();
  public readonly excel = output<void>();

  public readonly textos = TEXTOS_DESCARGA_SUPER_EJECUTIVO;
}
